// Inline single-stroke SVG icons (ported from vivid360-onboard).
// Kept as one map so callers can do <I.Mail size={16}/>.

const Ico = ({ d, size = 16, stroke = 2, className = '', children, viewBox = '0 0 24 24', fill = 'none' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={viewBox}
       fill={fill} stroke="currentColor" strokeWidth={stroke}
       strokeLinecap="round" strokeLinejoin="round" className={className}>
    {d ? <path d={d} /> : children}
  </svg>
);

export const I = {
  Mail:        (p) => <Ico {...p}><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></Ico>,
  MailCheck:   (p) => <Ico {...p}><path d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8"/><path d="m2 7 10 6 10-6"/><path d="m16 19 2 2 4-4"/></Ico>,
  Lock:        (p) => <Ico {...p}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></Ico>,
  Eye:         (p) => <Ico {...p}><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></Ico>,
  EyeOff:      (p) => <Ico {...p}><path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 2.12-.88"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c6.5 0 10 7 10 7a15.5 15.5 0 0 1-1.9 2.7"/><path d="M6.61 6.61A15.54 15.54 0 0 0 2 12s3.5 7 10 7a10.4 10.4 0 0 0 5.39-1.4"/><path d="m2 2 20 20"/></Ico>,
  Check:       (p) => <Ico {...p}><path d="M20 6 9 17l-5-5"/></Ico>,
  ChevronRight:(p) => <Ico {...p}><path d="m9 18 6-6-6-6"/></Ico>,
  ChevronLeft: (p) => <Ico {...p}><path d="m15 18-6-6 6-6"/></Ico>,
  AlertCircle: (p) => <Ico {...p}><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></Ico>,
  CircleCheck: (p) => <Ico {...p}><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></Ico>,
  Logout:      (p) => <Ico {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></Ico>,
  Key:         (p) => <Ico {...p}><circle cx="7.5" cy="15.5" r="3.5"/><path d="m10 13 10-10"/><path d="m16 7 3 3"/></Ico>,
};

// Square brand mark ,  used on the AuthDecor right panel and anywhere
// we want just the icon without the "Vivid360" type. Sourced from
// vivid360-portfolio/public/assets/vivid360-mark.png so the auth host
// stays visually consistent with vivid360.io.
//
// The unused ``color`` prop is kept for API back-compat with the
// previous SVG-based component (callers passed a hex string for
// dark-mode tweaks). Now it is a no-op since the PNG is full-colour.
export const VividMark = ({ size = 22 }) => (
  <img
    src="/assets/vivid360-mark.png"
    alt="Vivid360"
    width={size}
    height={size}
    style={{ display: 'block', objectFit: 'contain' }}
  />
);

// Full wordmark (icon + "Vivid360" type). Uses the same PNG asset the
// portfolio nav uses; one file, one source of truth.
export const VividWordmark = ({ height = 28 }) => (
  <img
    src="/assets/vivid360-wordmark.png"
    alt="Vivid360"
    style={{ height, width: 'auto', objectFit: 'contain', display: 'block' }}
  />
);

export const GoogleIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.99.66-2.25 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.11A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.11V7.05H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.95l3.66-2.84z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.05l3.66 2.84C6.71 7.29 9.14 5.38 12 5.38z"/>
  </svg>
);

export const MsIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect x="2"  y="2"  width="9" height="9" fill="#F25022"/>
    <rect x="13" y="2"  width="9" height="9" fill="#7FBA00"/>
    <rect x="2"  y="13" width="9" height="9" fill="#00A4EF"/>
    <rect x="13" y="13" width="9" height="9" fill="#FFB900"/>
  </svg>
);
